import { useEffect, useState, useContext } from "react";
import { TextsContext } from '../context/textsContext';
import { useCotizador } from "../context/apiContext";
import { useCalculations } from "./CalculationsHook";

function sortArrayByComponentId(a, b) {
	if (a.componentId === 15 && b.componentId !== 15) {
		return -1;
	} else if (b.componentId === 15 && a.componentId !== 15) {
		return 1;
	} else {
		return a.componentId - b.componentId;
	}
}

export const useFeeTable = () => {
	const { texts } = useContext(TextsContext);
	const { calculationValue, addDependant } = useCotizador();
	const { getMainFares, getDependantsFares/* , calculateValue */ } = useCalculations();

	const calculation = calculationValue

	const getName = (name) => {
		switch (name) {
			case "15":
				return texts?.general_form_option_spouse ?? 'Spouse';
			case 9:
				return texts?.general_table_title_main ?? 'Main Applicant';
			case "16":
				return texts?.general_form_option_children ?? 'Son/Daugther';
			case "-16":
				return texts?.general_form_option_other ?? 'Other';
			default:
				return name;
		}
	}

	const getTotalMain = () => {
		return {
			name: texts?.general_table_title_main ?? 'Main Applicant',
			annual: calculation?.data?.quotation?.ownerPremium,
			semiannual: calculation?.data?.quotation?.ownerPremium,
			quarterly: calculation?.data?.quotation?.ownerPremium,
			monthly: calculation?.data?.quotation?.ownerPremium,
		}
	}

	const getTotal = () => {
		return {
			name: texts?.general_table_title_total ?? 'Total',
			annual: calculation?.data?.quotation?.totalPremiumWithFee,
			semiannual: getPaymentTotal(calculation?.data, 1),
			quarterly: getPaymentTotal(calculation?.data, 1),
			monthly: getPaymentTotal(calculation?.data, 1),
		}
	}

	const getAdminFee = () => {
		return {
			name: texts?.general_table_title_fee ?? 'Admin Fee',
			annual: calculation?.data?.quotation?.fee,
			semiannual: calculation?.data?.quotation?.fee,
			quarterly: calculation?.data?.quotation?.fee,
			monthly: calculation?.data?.quotation?.fee
		}
	}

	const findPaymentByDependent = (quotes, beneficiaryType) => {
		if (quotes == undefined || quotes == null) return null
		return quotes.find(quote => quote.beneficiaryType == beneficiaryType)
	}

	const getPaymentDependent = () => {
		const paymentByDependent = findPaymentByDependent(calculation?.data?.quotation?.quotes, 'dependent')

		return {
			name: texts?.dependents_info_collapsible_title,
			annual: (paymentByDependent != null && paymentByDependent != undefined) ? paymentByDependent['annual'] : 0,
			semiannual: (paymentByDependent != null && paymentByDependent != undefined) ? paymentByDependent['semiannual'] : 0,
			quarterly: (paymentByDependent != null && paymentByDependent != undefined) ? paymentByDependent['quarterly'] : 0,
			monthly: (paymentByDependent != null && paymentByDependent != undefined) ? paymentByDependent['monthly'] : 0
		}
	}

	const getPaymentSpouse = () => {
		const paymentByDependent = findPaymentByDependent(calculation?.data?.quotation?.quotes, 'spouse')

		return {
			name: texts?.general_form_option_spouse_table,
			annual: (paymentByDependent != null && paymentByDependent != undefined) ? paymentByDependent['annual'] : 0,
			semiannual: (paymentByDependent != null && paymentByDependent != undefined) ? paymentByDependent['semiannual'] : 0,
			quarterly: (paymentByDependent != null && paymentByDependent != undefined) ? paymentByDependent['quarterly'] : 0,
			monthly: (paymentByDependent != null && paymentByDependent != undefined) ? paymentByDependent['monthly'] : 0
		}
	}

	const hasSpouse = () => {
		return findPaymentByDependent(calculation?.data?.quotation?.quotes, 'spouse')
	}

	const hasSon = () => {
		return findPaymentByDependent(calculation?.data?.quotation?.quotes, 'dependent')
	}

	const getTotalWithoutFee = () => {
		return {
			name: texts?.general_table_title_total ?? 'Total',
			annual: /* calculateValue("annual", true, false).toFixed(2) */0,
			semiannual: /* calculateValue("semiannual", true, false).toFixed(2) */0,
			quarterly: /* calculateValue("quarterly", true, false).toFixed(2) */0,
			monthly: /* calculateValue("monthly", true, false).toFixed(2) */ 0,
		}
	}

	const getFullRider = () => {
		const value = /* calculateValue('rider', true, false) */0;
		return {
			name: texts?.general_table_title_rider ?? 'Rider',
			annual: value,
			semiannual: value,
			quarterly: value,
			monthly: value,
		}
	}

	const getRider = () => {
		const values = getFullRider();
		return {
			name: texts?.general_table_title_rider ?? 'Rider',
			annual: Math.round(values.annual),
			semiannual: Math.round(values.annual),
			quarterly: Math.round(values.annual),
			monthly: Math.round(values.annual),
		}
	}

	const getFullPremiumAnnual = () => {
		return {
			name: texts?.general_table_title_Premium ?? 'Premium',
			annual: /* calculateValue("annual", false, false) */ 1333,
			semiannual: /* (calculateValue("semiannual", false, false)) */ 14,
			quarterly: /* (calculateValue("quarterly", false, false)) */ 88,
			monthly: /* (calculateValue("monthly", false, false)) */ 39,
		}
	}

	const getPremiumAnnual = () => {
		const values = getFullPremiumAnnual();
		return {
			name: texts?.general_table_title_Premium ?? 'Premium',
			annual: Math.round(values.annual),
			semiannual: Math.round(values.semiannual),
			quarterly: Math.round(values.quarterly),
			monthly: Math.round(values.monthly),
		}
	}

	const getPaymentTotal = (data, paymentNumber) => {
		if (!data || !data.quotation || !data.quotation.payments) {
			console.error("Invalid data");
			return 0;
		}

		const payments = data?.quotation?.payments;
		const selectedPayment = payments.find(payment => payment.paymentNumber === paymentNumber);

		return selectedPayment ? selectedPayment.totalAmount : 0;
	}

	const getOtherPayments = () => {
		return {
			name: texts?.general_table_title_Premium ?? 'Premium',
			annual: getPaymentTotal(calculation?.data, 2),
			semiannual: getPaymentTotal(calculation?.data, 2),
			quarterly: getPaymentTotal(calculation?.data, 2),
			monthly: getPaymentTotal(calculation?.data, 2),
		}
	}

	const getValues = () => {
		const toFix = (object) => {
			object.annual = calculation?.data?.quotation?.totalPremium;
			object.semiannual = calculation?.data?.quotation?.ownerPremium;
			object.quarterly = calculation?.data?.quotation?.ownerPremium;
			object.monthly = calculation?.data?.quotation?.ownerPremium;
			return object
		}
		const toFee = (fee) => {
			if (typeof fee === "string") {
				return parseFloat(Number(fee).toFixed(2));
			}
		}
		let main = getMainFares(true);
		main.name = getName(main.componentId);
		main = toFix(main)
		return [
			main,
			...(addDependant ? getDependantsFares(true)
				.filter(sortArrayByComponentId)
				.map(i => {
					i.name = getName(i.componentId)
					i = toFix(i)
					return i;
				}) : []),
			// getRider(),
			/* ...(fee.data?.data?.map(i => ({
				name: texts?.general_table_title_fee ?? 'Admin Fee', annual: toFee(i.fee), semiannual: toFee(i.fee), quarterly: toFee(i.fee), monthly: toFee(i.fee)
			})) ?? []), */
			{
				name: texts?.general_table_title_fee ?? 'Admin Fee',
				annual: calculation?.data?.quotation?.fee,
				semiannual: calculation?.data?.quotation?.fee,
				quarterly: calculation?.data?.quotation?.fee,
				monthly: calculation?.data?.quotation?.fee
			},
			getTotal(),
			// { name: "Annualized Premium", Anual: 8401.60, SemiAnnual: 4510.18, Quarterly: 2304.81 },
		];
	}

	const getValuesPdf = () => {
		const quotes = calculation?.data?.quotation?.quotes

		const order = {
			owner: 0,
			spouse: 1,
			dependent: 2
		};

		const sortedItems = quotes.sort((a, b) => {
			const priorityA = order[a.beneficiaryType] ?? 999
			const priorityB = order[b.beneficiaryType] ?? 999
			return priorityA - priorityB;
		})

		return sortedItems
	}

	const [list, setList] = useState(getValues())




	useEffect(() => {
		setList(getValues());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [/*fare , fee */])

	return {
		list,
		getTotal,
		getTotalMain,
		getAdminFee,
		getPaymentDependent,
		getPaymentSpouse,
		hasSpouse,
		hasSon,
		getOtherPayments,
		getRider,
		getPremiumAnnual,
		getFullPremiumAnnual,
		getFullRider,
		getValuesPdf
	};
}